import { render, staticRenderFns } from "./shop_stocks.vue?vue&type=template&id=de4e1152"
import script from "./shop_stocks.vue?vue&type=script&lang=js"
export * from "./shop_stocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports